import api from '../../common/services/api';
import Notification from '../../components/Notification';
import constants from '../../config/constants';

export const getMyExams = async (myQuerySimulates, newQueryData) => {
    try {
        newQueryData = newQueryData || 0;
        const {data} = await api.get(`/exam/myExams`, {
            params: {
                ...myQuerySimulates,                
                ...newQueryData
            }
        }) 

        return data;

    } catch(error) {
        Notification.error({
            message: 'Sua sessão expirou.'
        })
        if (error.status === 401) {
            localStorage.removeItem('token')
            localStorage.removeItem('bedukaUser')
            window.location.href = `${constants.SIMULADO_V2_URL}`
        }
    }
}